import React, { Component } from 'react'
import { connect } from 'react-redux';
import FuelSurcharge from '~/components/common/FuelSurcharge';
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css'
class FuelSurchargePage extends Component {
  constructor(props){
    super(props);
  }
  render() {
    return(
      <div className={css.page}>
        <div className={css.title}>
            Fuel Surcharge Calculator
        </div>
        <div className={css.warp}>
          <FuelSurcharge
          />
        </div>
      </div>
    )
  }
}

export default connect(()=>{
  return {}
},mapDispatch({
  
}))(FuelSurchargePage)



// WEBPACK FOOTER //
// ./src/pages/FuelSurchargePage/index.js